// extracted by mini-css-extract-plugin
export default {"about__text__wrapper":"About_about__text__wrapper__TQ2bl"};